import script from "./FormView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormView.vue?vue&type=script&setup=true&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=4e3ee132&lang=css"
import "./FormView.vue?vue&type=style&index=1&id=4e3ee132&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3ee132"]])

export default __exports__